// extracted by mini-css-extract-plugin
export default {"option":"styles_option__tIzh2","selectedOption":"styles_selectedOption__zkiUO","dotIcon":"styles_dotIcon__8nqAu"};